export const CONTENT_VIEW = {
  CHAT_VIEW: 'CHAT_VIEW',
  TEAM_CARD_VIEW: 'TEAM_CARD_VIEW',
  CREATE_TEAM_VIEW: 'CREATE_TEAM_VIEW',
  EDIT_TEAM_VIEW: 'EDIT_TEAM_VIEW',
  EDIT_PROFILE_VIEW: 'EDIT_PROFILE_VIEW',
  SUBMIT_PROJECT_VIEW: 'SUBMIT_PROJECT_VIEW',
  INVITE_VIEW: 'INVITE_VIEW'
};

export const SUBMISSION_SORT_BY = {
  TEAMSIZE_ASC: 'TEAMSIZE_ASC',
  TEAMSIZE_DES: 'TEAMSIZE_DES',
  TEAMNAME_ASC: 'TEAMNAME_ASC',
  TEAMNAME_DES: 'TEAMNAME_DES',
  SUBMISSIONNAME_ASC: 'SUBMISSIONNAME_ASC',
  SUBMISSIONNAME_DES: 'SUBMISSIONNAME_DES',
  LIKES_ASC: 'LIKES_ASC',
  LIKES_DES: 'LIKES_DES',
  UPDATED_ASC: 'UPDATED_ASC',
  UPDATED_DES: 'UPDATED_DES'
};

// export const SUBMISSION_SORTING_OPTIONS = [
//   {
//     key: SUBMISSION_SORT_BY.TEAMSIZE_ASC,
//     text: 'Team Size: Low to High',
//     value: SUBMISSION_SORT_BY.TEAMSIZE_ASC,
//     icon: 'sort numeric ascending',
//   },
//   {
//     key: SUBMISSION_SORT_BY.TEAMSIZE_DES,
//     text: 'Team Size: High to Low',
//     value: SUBMISSION_SORT_BY.TEAMSIZE_DES,
//     icon: 'sort numeric descending',
//   },
// ];
export const SUBMISSION_SORTING_OPTIONS = [
  {
    key: SUBMISSION_SORT_BY.SUBMISSIONNAME_ASC,
    text: 'Submission Name: A to Z',
    value: SUBMISSION_SORT_BY.SUBMISSIONNAME_ASC,
    icon: 'sort alphabet ascending'
  },
  {
    key: SUBMISSION_SORT_BY.SUBMISSIONNAME_DES,
    text: 'Submission Name: Z to A',
    value: SUBMISSION_SORT_BY.SUBMISSIONNAME_DES,
    icon: 'sort alphabet descending'
  },
  {
    key: SUBMISSION_SORT_BY.TEAMNAME_ASC,
    text: 'Team Name: A to Z',
    value: SUBMISSION_SORT_BY.TEAMNAME_ASC,
    icon: 'sort alphabet ascending'
  },
  {
    key: SUBMISSION_SORT_BY.TEAMNAME_DES,
    text: 'Team Name: Z to A',
    value: SUBMISSION_SORT_BY.TEAMNAME_DES,
    icon: 'sort alphabet descending'
  },
  {
    key: SUBMISSION_SORT_BY.LIKES_ASC,
    text: 'Likes: Low to High',
    value: SUBMISSION_SORT_BY.LIKES_ASC,
    icon: 'sort numeric ascending'
  },
  {
    key: SUBMISSION_SORT_BY.LIKES_DES,
    text: 'Likes: High to Low',
    value: SUBMISSION_SORT_BY.LIKES_DES,
    icon: 'sort numeric descending'
  },
  {
    key: SUBMISSION_SORT_BY.UPDATED_ASC,
    text: 'Submitted: new to old',
    value: SUBMISSION_SORT_BY.UPDATED_ASC,
    icon: 'sort numeric ascending'
  },
  {
    key: SUBMISSION_SORT_BY.UPDATED_DES,
    text: 'Submitted: old to new',
    value: SUBMISSION_SORT_BY.UPDATED_DES,
    icon: 'sort numeric descending'
  }
];

export const SORT_BY = {
  TEAMNAME_ASC: 'NAME_ASC',
  TEAMNAME_DES: 'NAME_DES',
  // CREATOR_ASC: 'CREATOR_ASC',
  // CREATOR_DES: 'CREATOR_DES',
  TEAMSIZE_ASC: 'TEAMSIZE_ASC',
  TEAMSIZE_DES: 'TEAMSIZE_DES',
  TEAMSPOT_ASC: 'TEAMSPOT_ASC',
  TEAMSPOT_DES: 'TEAMSPOT_DES',
  MATCHING_PERCENT_ASC: 'MATCHING_PERCENT_ASC',
  MATCHING_PERCENT_DES: 'MATCHING_PERCENT_DES'
};

export const TEAM_NAME_SORTING_OPTIONS = [
  {
    key: SORT_BY.TEAMNAME_ASC,
    text: 'Team Name: A to Z',
    value: SORT_BY.TEAMNAME_ASC,
    icon: 'sort alphabet ascending'
  },
  {
    key: SORT_BY.TEAMNAME_DES,
    text: 'Team Name: Z to A',
    value: SORT_BY.TEAMNAME_DES,
    icon: 'sort alphabet descending'
  }
];

export const TEAM_SIZE_SORTING_OPTIONS = [
  {
    key: SORT_BY.TEAMSIZE_ASC,
    text: 'Team Size: Low to High',
    value: SORT_BY.TEAMSIZE_ASC,
    icon: 'sort numeric ascending'
  },
  {
    key: SORT_BY.TEAMSIZE_DES,
    text: 'Team Size: High to Low',
    value: SORT_BY.TEAMSIZE_DES,
    icon: 'sort numeric descending'
  }
];

export const MATCHING_PERCENT_SORTING_OPTIONS = [
  {
    key: SORT_BY.MATCHING_PERCENT_ASC,
    text: 'Matching Score: Low to High',
    value: SORT_BY.MATCHING_PERCENT_ASC,
    icon: 'sort numeric ascending'
  },
  {
    key: SORT_BY.MATCHING_PERCENT_DES,
    text: 'Matching Score: High to Low',
    value: SORT_BY.MATCHING_PERCENT_DES,
    icon: 'sort numeric descending'
  }
];

export const EVENT_TEAM_SIDEBAR_TABS = {
  TEAM_TAB: 'TEAM_TAB',
  PROFILE_TAB: 'PROFILE_TAB'
};

export const EVENT_MY_TEAM_SIDEBAR_TABS = {
  OVERVIEW: 'OVERVIEW',
  CHAT: 'CHAT',
  INVITE: 'INVITE',
  EDIT: 'EDIT',
  SUBMIT: 'SUBMIT',
  LEAVE: 'LEAVE'
};

export const EVENT_JUDGING_SIDEBAR_TABS = {
  RATING: 'RATING'
};

export const ITEM_PER_PAGE = 11;



// WEBPACK FOOTER //
// ./src/components/events/constant.js